import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import DataController from 'components/DataController/DataController';
import { IItemGameDeveloper } from 'types';
import {
	GameDevelopersContext,
	IGameDevelopersContext,
} from 'modules/Entertainment/Games/GameDevelopers/gameDevelopersState/gameDevelopersContext';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemGameDeveloper;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForDeletion, setIDForEdit } = useContext<IGameDevelopersContext>(GameDevelopersContext);

	const developersRowClasses = classNames(style.row, style.developers);
	const actionRowClasses = classNames(style.row, style.action);

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	const handleEdit = () => {
		setIDForEdit(data.id);
	};

	return (
		<div data-test={`Item-${index}`} className={style.container}>
			<Text className={developersRowClasses} translationKey={data.name} withTooltip={true} />
			<div className={actionRowClasses}>
				<DataController onClickDelete={handleSetIdForDeletion} onClickEdit={handleEdit} size="smallBtn" />
			</div>
		</div>
	);
};

export default Item;
